/**
 * AMSTAR2 answer-payload schemas.
 *
 * Runtime Zod schemas and derived types for the `data` passed to
 * `handler.updateAnswer(answersMap, key, data)`. Distinct from the rendering
 * schema in `schema.ts` (which describes question UI) and the broader
 * interfaces in `../types.ts`.
 */
import { z } from 'zod';
// Both fields optional: an update carries only what actually changed, so a
// concurrent answer click and critical toggle on the same question never
// clobber each other's row (rows are last-writer-wins upserts, not merges).
export const Amstar2QuestionAnswerSchema = z.object({
    answers: z.array(z.array(z.boolean())).optional(),
    critical: z.boolean().optional(),
});
export const Amstar2AnswersSchema = z.object({
    q1: Amstar2QuestionAnswerSchema,
    q2: Amstar2QuestionAnswerSchema,
    q3: Amstar2QuestionAnswerSchema,
    q4: Amstar2QuestionAnswerSchema,
    q5: Amstar2QuestionAnswerSchema,
    q6: Amstar2QuestionAnswerSchema,
    q7: Amstar2QuestionAnswerSchema,
    q8: Amstar2QuestionAnswerSchema,
    q9a: Amstar2QuestionAnswerSchema,
    q9b: Amstar2QuestionAnswerSchema,
    q10: Amstar2QuestionAnswerSchema,
    q11a: Amstar2QuestionAnswerSchema,
    q11b: Amstar2QuestionAnswerSchema,
    q12: Amstar2QuestionAnswerSchema,
    q13: Amstar2QuestionAnswerSchema,
    q14: Amstar2QuestionAnswerSchema,
    q15: Amstar2QuestionAnswerSchema,
    q16: Amstar2QuestionAnswerSchema,
});
export const AMSTAR2_KEY_SCHEMAS = {
    q1: Amstar2QuestionAnswerSchema,
    q2: Amstar2QuestionAnswerSchema,
    q3: Amstar2QuestionAnswerSchema,
    q4: Amstar2QuestionAnswerSchema,
    q5: Amstar2QuestionAnswerSchema,
    q6: Amstar2QuestionAnswerSchema,
    q7: Amstar2QuestionAnswerSchema,
    q8: Amstar2QuestionAnswerSchema,
    q9a: Amstar2QuestionAnswerSchema,
    q9b: Amstar2QuestionAnswerSchema,
    q10: Amstar2QuestionAnswerSchema,
    q11a: Amstar2QuestionAnswerSchema,
    q11b: Amstar2QuestionAnswerSchema,
    q12: Amstar2QuestionAnswerSchema,
    q13: Amstar2QuestionAnswerSchema,
    q14: Amstar2QuestionAnswerSchema,
    q15: Amstar2QuestionAnswerSchema,
    q16: Amstar2QuestionAnswerSchema,
};
export function isAmstar2Key(key) {
    return key in AMSTAR2_KEY_SCHEMAS;
}
//# sourceMappingURL=answers-schema.js.map